export const VARIANT = {
  default: 'outlined',
  custom: 'standard',
};
